// import AccountAdd from '@/views/accounts/accounts-details/account-add';
// import AccountDetailsInfo from '@/views/accounts/accounts-details/account-details-info/index.vue';
const AccountDetailsInfo = () =>
    import(/* webpackChunkName: "AccountDetailsInfo" */ '@/views/accounts/accounts-details/account-details-info');
const ActionsDetail = () => import(/* webpackChunkName: "ActionsDetail" */ '@/components/actions-detail');
import AccountAux from '@/views/accounts/accounts-details/account-aux/index.vue';
import AccountBankAccounts from '@/views/accounts/accounts-details/account-bank-accounts/index.vue';
import AccountInfoBox from '@/views/accounts/accounts-details/account-info-box/index.vue';
import Bastanteo from '@/views/shared/bastanteo/index.vue';
// import IntervenerAdd from '@/views/intervener-add';
import permissionUser from '@/inheritance/permission-user';
import RelatedDocumentation from '@/views/shared/related-documentation/index.vue';
import RelatedHistoric from '@/views/shared/related-historic/index.vue';
import RelatedInterveners from '@/views/shared/related-interveners/index.vue';
import RelatedBeneficiaries from '@/views/shared/related-beneficiaries/index.vue';
import RelatedIssues from '@/views/shared/related-issues/index.vue';
import RelatedOperations from '@/views/shared/related-operations/index.vue';
import RelatedAssociates from '@/views/shared/related-associates/index.vue';
import RelatedPatrons from '@/views/shared/related-patrons/index.vue';

export default {
    name: 'AccountsDetails',

    extends: permissionUser,

    props: {
        id: {
            type: String,
            required: false
        }
    },
    components: {
        AccountAux,
        AccountBankAccounts,
        AccountDetailsInfo,
        AccountInfoBox,
        ActionsDetail,
        Bastanteo,
        RelatedDocumentation,
        RelatedHistoric,
        RelatedInterveners,
        RelatedBeneficiaries,
        RelatedIssues,
        RelatedOperations,
        RelatedAssociates,
        RelatedPatrons
    },
    /**
     * @override
     */
    data() {
        return {
            account: null,
            uuid_account: null,
            tabs: ['Detalles', 'Relacionado', 'Casos', 'Auxiliar', 'Cuentas bancarias', 'Bastanteo'],
            accountIssues: [],
            accountIssuesResolved: [],
            accountIssuesNotResolved: [],
            pendingAccountIssues: 0,
            tabIndexSelected: 0,
            componentKey: 0,
            numberItemsNotValidated: 0,
            accountPositions: [],
            pendingItems: new Set(),
            accountIntervenersRisk: [],
        };
    },

    /**
     * @override
     */
    mounted() {
        this.$root.$off('refresh_account', this.fetchData);
        this.$root.$on('refresh_account', this.fetchData);
        /**
         * TOTAL de items no validados
         * Emit lanzado desde el componente BastanteoGroup
         */
        this.$root.$off('emit_items_not_validated', this.updateItemsNotValidated);
        this.$root.$on('emit_items_not_validated', this.updateItemsNotValidated);
    },
    /**
     * @override
     */
    beforeDestroy() {
        // Al destruir el componente, se destruyen los listener de eventos en el root
        this.$root.$off('refresh_account', this.fetchData);
        this.$root.$off('emit_items_not_validated', this.updateItemsNotValidated);
    },

    /**
     * Comprueba que la URL cambia y obtiene los datos
     */
    watch: {
        $route: {
            /**
             * Comprobamos con un watch si la URL ha cambiado y obtenemos los datos
             */
            handler() {
                this.account = null;
                this.saving = false;
                this.savingTitle = 'Guardar cambios';

                if (this.$route.name !== 'accounts_add') {
                    this.fetchData();
                }
            },
            immediate: true
        }
    },
    methods: {
        /**
         * Indicamos el tab activo
         * @param {Number} index Indice del tab activo
         */
        setTabIndexSelected(index) {
            this.tabIndexSelected = index;
            localStorage.setItem(`tabs_account_${this.uuid_account}`, index);
        },

        /**
         * Obtenemos la información de la cuenta
         */
        fetchData() {
            this.numberItemsNotValidated = 0;
            this.pendingItems.clear();
            this.uuid_account = this.id || this.$route.params.uuid;
            this.tabIndexSelected = +localStorage.getItem(`tabs_account_${this.uuid_account}`);
            this.loadAccount(this.uuid_account);
            this.loadAccountIssues(this.uuid_account);
            if( this.amlAllowed ) this.loadAccountAml(this.uuid_account);
        },    
        /**
         * Obtenemos la cuenta desde el servicio
         * @param {String} uuid ID de la cuenta
         */
        async loadAccount(uuid) {
            try {
                const params = {
                    extCodesFromSM: this.allowExternalCodesFromSystemMappings 
                }
                
                const res = await this.$accountsService.getAccountsByUUId(uuid, { params })
                this.account = res.data.account;
                if (!this.account.subdistributor) {
                    this.account.subdistributor = {};
                }
                if (this.account.draft_data) {
                    this.numberItemsNotValidated++;
                }
                this.componentKey++;
                this.$store.dispatch('loaderStore/isVisible', false);
            } catch (err) {
                this.$toast.error(err.name, err.message)
            }
        },
        /**
         * Obtenemos obtenemos las incidencias del interviniente desde el servicio
         * @param {String} uuid ID del interviniente
         */
        loadAccountIssues(uuid) {
            this.$accountsService.getAccountIssues(uuid).then(res => {
                this.accountIssues = res.data.accounts_issues || [];
                this.accountIssues = this.accountIssues.filter(item => item.uuid);
                this.accountIssuesResolved = this.accountIssues.filter(item => item.status === 'RESOLVED');
                this.accountIssuesNotResolved = this.accountIssues.filter(item => item.status !== 'RESOLVED');
                this.pendingAccountIssues = this.accountIssuesNotResolved.length;
            });
        },

        /**
         * Update account information on status update
         */
        accountStatusHasChanged() {
            this.fetchData();
        },

        /**
         * ACTUALIZA ITEMS NO VALIDADOS
         * Emit lanzado desde el componente BastanteoItem
         *
         * @param {Object} items: items no validados
         *
         */
        updateItemsNotValidated(items) {
            let newItems = 0;
            items.forEach(item => {
                if (!this.pendingItems.has(item.uuid)) {
                    this.pendingItems.add(item.uuid);
                    newItems++;
                }
            });
            // Sumar solo los nuevos elementos
            this.numberItemsNotValidated += newItems; 
        },             
        accountPositionsGot(accountPositions) {
            this.accountPositions = accountPositions;
        },
        async loadAccountAml(uuid){
            try {
                const res = await this.$intervenersService.getAccountAml(uuid)
                const amlInfo = res.data
                this.accountIntervenersRisk = amlInfo.interveners.filter( i => i.aml && ['high', 'medium'].includes(i.aml.risk)); 
            } catch (error) {
                console.error('Error fetching risk info', error);
            } 
        },
    },
    computed: {
        /**
         * Indica si estamos editando un usuario o no
         * @return {Boolean} Editable true/false
         */
        editable() {
            if (this.actionObject('ACCOUNTS', 'edit')) {
                return this.$route.query && (this.$route.query.edit === true || this.$route.query.edit === 'true')
                    ? true
                    : false;
            }
            return false;
        },

        amlAllowed() {
            return this.$store.getters['configVarsStore/getAllowAML'];
        },

        allowExternalCodesFromSystemMappings() {
            return this.$store.getters['configVarsStore/getAllowExternalCodesFromSM'];
        },
    }
};
